<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline" size="small">
                <el-form-item>
                    <el-input v-model.trim="search.kname" placeholder="模糊搜索名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="search.code" placeholder="套餐编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.status" multiple placeholder="状态集合">
                        <el-option label="测试" :value="0"></el-option>
                        <el-option label="上架" :value="1"></el-option>
                        <el-option label="下架" :value="2"></el-option>
                        <el-option label="已删除" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.region" clearable placeholder="区域">
                        <el-option label="cn" value="cn"></el-option>
                        <el-option label="eu" value="eu"></el-option>
                        <el-option label="us" value="us"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.is_event" clearable placeholder="是否为事件">
                        <el-option label="否" :value="0"></el-option>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="全部" :value="-1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.level" clearable placeholder="服务等级">
                        <el-option v-for="item in levelList" :key="item.set_meal_level" :label="item.level_name"
                            :value="item.set_meal_level">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="Search">查询</el-button>
                </el-form-item>
            </el-form>
            <div>
                <router-link :to="'/iot/packadd/' + 0">
                    <el-button type="primary" size="small">新建</el-button>
                </router-link>
            </div>
        </div>
        <!-- 列表 -->
        <el-table border v-bind:data="list" @sort-change="Sortchange" size="small">
            <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
            <el-table-column label="套餐名称" sortable>
                <template v-slot="scope">
                    <span>{{ scope.row.SetMeal.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="套餐时长" sortable width="100">
                <template v-slot="scope">
                    <span>{{
                        scope.row.SetMeal.time +
                        '(' +
                        scope.row.SetMeal.time_unit +
                        ')'
                        }}</span>
                </template>
            </el-table-column>
            <el-table-column label="原价" width="60">
                <template v-slot="scope">
                    <span>{{ scope.row.SetMeal.price }}</span>
                </template>
            </el-table-column>
            <el-table-column label="售价" width="60">
                <template v-slot="scope">
                    <span>{{ scope.row.SetMeal.saleprice }}</span>
                </template>
            </el-table-column>
            <el-table-column label="套餐状态" width="140">
                <template v-slot="scope">
                    <el-select v-model="scope.row.SetMeal.status" @change="changeStatus(scope.row.SetMeal)"
                        size="small">
                        <el-option label="测试" :value="0"></el-option>
                        <el-option label="上架" :value="1"></el-option>
                        <el-option label="下架" :value="2"></el-option>
                        <el-option label="已删除" :value="3"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="文件时长(天)" sortable width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.SetMeal.file_time }}</span>
                </template>
            </el-table-column>
            <el-table-column label="服务等级" width="80">
                <template v-slot="scope">
                    <span>{{ getServiceLevelLabel(scope.row.SetMeal.level) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="是否针对事件存储" width="120">
                <template v-slot="scope">
                    <span>{{
                        scope.row.SetMeal.is_event == 0
                            ? '否'
                            : scope.row.SetMeal.is_event == 1
                                ? '是'
                                : '未知'
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="区域" width="60">
                <template v-slot="scope">
                    <span>{{ scope.row.SetMeal.region }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="380px">
                <template v-slot="scope">
                    <router-link style="margin-right:10px" :to="'/iot/pack/sale/' + scope.row.SetMeal.code">
                        <el-button type="info" size="mini">折扣信息</el-button>
                    </router-link>
                    <router-link style="margin-right:10px" :to="'/iot/packadd/' + scope.row.SetMeal.code">
                        <el-button type="primary" size="mini">修改</el-button>
                    </router-link>
                    <router-link style="margin-right:10px" :to="'/iot/pack/distribute/' + scope.row.SetMeal.code">
                        <el-button type="info" size="mini">设备分配</el-button>
                    </router-link>
                    <router-link style="margin-right:10px" :to="'/iot/pack/ruledistribute/' + scope.row.SetMeal.code">
                        <el-button type="info" size="mini">用户分配</el-button>
                    </router-link>
                    <!-- <el-button type="danger" size="small" @click="deletePack(scope.row.SetMeal.code)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page" :page-size="search.limit"
            layout="total, prev, pager, next" :total="total">
        </el-pagination>
    </div>
</template>

<script type="text/ecmascript-6">
import api from '../../../axios/pack'
import util from '../../../util/util'
export default {
    name: '',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            search: {
                page: 1,
                limit: 10,
                kname: '',
                code: '',
                status: [0, 1],
                is_event: -1,
                order_field: '',
                order_action: 1,
                region: '',
                level: ''
            },
            list: [],
            total: 0,
            currencylist: [],
            levelMap: {},
            levelList: []
        }
    },
    computed: {},
    watch: {},
    methods: {
        getServiceLevelLabel(level) {
            return this.levelMap[level] || ''
        },
        GetPackageLevelList() {
            api.PackageLevelList({}).then(res => {
                if (res.data.code == 200) {
                    res.data.data.data.forEach(v => {
                        this.levelList = res.data.data.data
                        this.levelMap[v.set_meal_level] = v.level_name
                    })
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        // 处理套餐下架-删除绑定规则
        handleRomvePack(code) {
            return new Promise((resolve, reject) => {
                api.RulePackDistriList({
                    set_meal_code: code
                }).then(res => {
                    if (res.data.code == 200) {
                        const ruleList = res.data.data
                        if (ruleList.length === 0) {
                            resolve()
                            return
                        }

                        // 删除所有绑定规则
                        const deletePromises = ruleList.map(rule => {
                            return api.RulePackDistriDelete({
                                set_meal_code: code,
                                rule_code: rule.rule_code,
                                region: rule.region
                            })
                        })

                        Promise.all(deletePromises).then(results => {
                            const allSuccess = results.every(res => res.data.code == 200)
                            if (allSuccess) {
                                this.$message.success('所有绑定规则删除成功')
                                resolve()
                            } else {
                                this.$message.error('部分绑定规则删除失败')
                                reject('部分绑定规则删除失败')
                            }
                        }).catch(error => {
                            this.$message.error('删除绑定规则失败')
                            reject(error)
                        })
                    } else {
                        this.$message.error('获取绑定规则失败' + res.data.msg)
                        reject(res.data.msg)
                    }
                }).catch(error => {
                    this.$message.error('获取绑定规则失败')
                    reject(error)
                })
            })
        },
        GetCurrency() {
            this.api.CurrencyList({
                page: 1,
                limit: 100,
            }).then(res => {
                if (res.data.code == 200) {
                    this.currencylist = res.data.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        Sortchange(column) {
            switch (column.column.label) {
                case '套餐名称':
                    this.search.order_field = 'name'
                    break
                case '套餐时长':
                    this.search.order_field = 'time'
                    break
                case '套餐价格/售价':
                    this.search.order_field = 'price'
                    break
                case '币种':
                    this.search.order_field = 'currency'
                    break
                case '文件时长(天)':
                    this.search.order_field = 'file_time'
                    break
            }
            this.search.order_action = this.search.order_action == 1 ? 2 : 1
            this.Search()
        },
        handleCurrentChange(val) {
            this.search.page = val
            sessionStorage.setItem('currentPage', val)
            this.Search()
        },
        Search() {
            api.PackageList({
                page: this.search.page,
                limit: this.search.limit,
                kname: this.search.kname,
                code: this.search.code,
                region: this.search.region,
                level: this.search.level,
                status: JSON.stringify(this.search.status),
                is_event: this.search.is_event,
                order_field: this.search.order_field,
                order_action: this.search.order_action,
            }).then(res => {
                console.log('PackageList: ', res)
                if (res.data.code == 200) {
                    this.list = res.data.data.data
                    this.total = res.data.data.page_info.total
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        changeStatus(item) {
            // 如果是下架操作(status为2)，先删除绑定规则
            if (item.status === 2) {
                this.handleRomvePack(item.code).then((r) => {
                    console.log('handleRomvePack', r)
                    // 删除绑定规则成功后，执行下架操作
                    this.executeStatusChange(item)
                }).catch(error => {
                    // 删除绑定规则失败，恢复原状态
                    this.$message.error('下架失败，请先处理绑定规则')
                    this.Search() // 刷新列表恢复原状态
                })
            } else {
                // 其他状态直接修改
                this.executeStatusChange(item)
            }
        },
        executeStatusChange(item) {
            api.PackageChangeStatus({
                set_meal_code: item.code,
                status: item.status,
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('状态修改成功')
                    this.Search()
                    return
                }
                this.$message.error('状态修改失败' + res.data.msg)
            })
        },
        deletePack(item) {
            this.$confirm('是否删除该套餐?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除请求
                api.PackDelete({ code: item }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                        this.Search()
                        return
                    }
                    this.$message.error('删除失败' + res.data.msg)
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消删除'
                })
            })
        },
        changeTime(item) {
            return util.dateFormat(item)
        },
        getSchoolWebModuleMessageListFunc() {
            setTimeout(() => {
                if (sessionStorage.getItem("currentPage") && sessionStorage.getItem("currentPage") !== 1) {
                    this.search.page = Number(sessionStorage.getItem("currentPage"))
                }
                this.Search()
            }, 0)
        }
    },
    filters: {},
    mounted() {
        this.getSchoolWebModuleMessageListFunc()
    },
    created() {
        this.GetCurrency()
        this.GetPackageLevelList()
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus"></style>
